module.exports = __webpack_public_path__ + "img/error-dark.9c0c244c.svg";